<template>
  <nav v-if="show">
    <header>
      <router-link to="/" title="Przejdź do strony głównej"><h1>Wirtualne Biuro</h1></router-link>
      <ul>
        <li @click="hideMobileNav()"><i class="material-icons" title="Zamknij menu">close</i></li>
      </ul>
    </header>
    <ul class="links">
      <li><router-link :class="{ active: route == 'Landing' }" to="/" title="Strona główna">Strona główna</router-link></li>
      <li><router-link :class="{ active: route == 'Packets' }" to="/pakiety" title="Pakiety">Pakiety</router-link></li>
      <li><router-link :class="{ active: route == 'Faq' }" to="/faq" title="Faq">FAQ</router-link></li>
      <li><router-link :class="{ active: route == 'Gallery' }" to="/galeria" title="Galeria">Galeria</router-link></li>
      <li><a :href="panel" title="Panel klienta">Panel klienta</a></li>
      <!-- <li><router-link to="/blog" title="Blog">Blog</router-link></li> -->
      <li><a href="https://www.afk-cob.pl/" title="Przedź do strony głównej AFK COB">AFK COB</a></li>
      <li><router-link :class="{ active: route == 'Contact' }" to="/kontakt" title="Kontakt">Kontakt</router-link></li>
      <li class="info bottom">
        <i class="material-icons">phone</i>
        <a href="tel:+48713369521">+48 71 336 95 21</a>
      </li>
      <li class="info">
        <i class="material-icons">email</i>
        <a href="mailto:bok@afkcob.pl">bok@afkcob.pl</a>
      </li>
      <!-- <li class="info">
        <i class="material-icons">language</i>
        <ul>
          <li :class="{ active: language.value == 1 }" v-for="language in languagesAll" :key="language.name" @click.prevent="changeLanguage(language.name)">{{ language.name }}</li>
        </ul>
      </li> -->
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'NavMobile',
  data(){
    return{
      active: 0,
      languagesAll: [{ name: 'pl', value: 0 }, { name: 'en', value: 0 }, { name: 'de', value: 0 }, { name: 'ua', value: 0 }],
    }
  },
  computed:{
    show(){
      return this.$store.state.mobileNav;
    },
    route(){
      return this.$store.state.route;
    },
    panel() {
      return this.$store.state.panel;
    },
  },
  created(){
    if(typeof localStorage.language === 'undefined'){
      this.changeLanguage('pl');
    }else{
      this.changeLanguage(localStorage.language)
    }
  },
  methods:{
    hideMobileNav(){
      this.$store.commit('toggleMobileNav');
      document.body.style = "overflow-y: overlay";
    },
    showLogin(){
      this.$store.commit('changeLogin', 1);
      document.body.style = "overflow-y: hidden";
    },
    changeLanguage(name){
      for(let i = 0; i < this.languagesAll.length; i++){
        if(name == this.languagesAll[i].name){
          this.languagesAll[i].value = 1;
        }else{
          this.languagesAll[i].value = 0;
        }
      }
    },
  }
}
</script>

<style scoped lang="scss">
  nav { width: 100%; min-height: 100%; max-height: 100%; position: fixed; top: 0; padding: 0; background: $grayDark; overflow-y: auto; z-index: 3; box-sizing: border-box; }
  nav header { display: flex; align-items: center; justify-content: space-between; height: 60px; border-bottom: 1px solid rgba(255, 255, 255, 0.1); }
  nav header h1 { margin: 0 0 0 20px; padding: 0 0 0 67px; font-size: 24px; color: #fff; font-family: 'Fira Sans', sans-serif; font-weight: 300; text-decoration: none; 
    background: url('../assets/logo_27_white.png') no-repeat; cursor: pointer; font-family: 'Aspergit Regular', sans-serif; letter-spacing: 1px; text-indent: -999px; }
  nav header a { text-decoration: none; }
  nav header ul { margin: 0; padding: 0; list-style: none; }
  nav header li { display: flex; justify-content: center; flex-shrink: 0; align-items: center; width: 60px; height: 60px;  }
  nav header li i.material-icons { color: rgba(255, 255, 255, 1); font-size: 32px; cursor: pointer; }
  nav ul.links { display: flex; flex-direction: column; min-height: calc(100vh - 60px); margin: 0; padding: 0; list-style: none; box-sizing: border-box; }
  nav ul.links li { height: 60px; }
  nav ul.links li a { display: block; text-align: center; line-height: 60px; text-decoration: none; font-weight: 500; font-size: 16px; 
    color: rgba(255, 255, 255, 1); }
  nav ul.links li a.active { background: rgba(255, 255, 255, 0.1); }
  nav ul.links li a:hover { background: rgba(255, 255, 255, 0.1); }

  nav ul.links li.info.bottom { margin-top: auto; }
  nav ul.links li.info { display: flex; justify-content: flex-end; align-items: center; padding: 0 20px; }
  nav ul.links li.info i.material-icons { margin: 0 5px 0 0; color: rgba(255, 255, 255, 0.5); font-size: 18px; }
  nav ul.links li.info a { margin: 0 0 0 5px; padding: 0; color: rgba(255, 255, 255, 0.5); font-weight: 400; font-size: 16px; }
  nav ul.links li.info a:hover { background: none; }
  nav ul.links li.info ul { display: flex; height: 60px; align-items: center; margin: 0; padding: 0; list-style: none; }
  nav ul.links li.info ul li { margin: 0 5px; width: initial; height: initial; color: rgba(255, 255, 255, 0.5); text-transform: uppercase; }
  nav ul.links li.info ul li.active { color: $orangeDark; }
  nav ul.links li.info ul li:last-child { margin: 0 0 0 5px; }
</style>
